import en from './en-CA';
import fr from './fr-CA';

import enGlossary from './en-CA-Glossary';
import enCitations from './en-CA-Citations';
import enFAQ from './en-CA-FAQ';

export default {
  'en-CA': en,
  'fr-CA': fr
};

export const glossaries = {
  'en-CA': enGlossary
};

export const citations = {
  'en-CA': enCitations
};

export const questions = {
  'en-CA': enFAQ
};
